import { Navigate } from "react-router-dom";
import { isAuthenticated, isAdmin } from "../utils/auth";

// 보호된 라우트를 감싸는 컴포넌트.
// 토큰이 없거나 Admin이 아니면 로그인 페이지로 리다이렉트.
// App.js에서 children을 감싸서 사용.
function ProtectedRoute({ children }) {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin()) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedRoute;
